<template>
  <IconWrapper
    name="dropdown"
    :color="color"
    fillMode="stroke"
    :style="{ transform: deployed ? 'rotate(180deg)' : 'rotate(0deg)' }"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 8.5L12 15.5L5 8.5"
        stroke="#1B1B1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </IconWrapper>
</template>

<script setup lang="ts">
import IconWrapper from './wrapper/wrapper.vue'

import type { ColorsType } from '@/types'

defineProps<{
  color: ColorsType
  deployed?: boolean
}>()
</script>
